export const coffees = [
  {
    id: 'c1',
    name: 'Finca El Puente',
    origin: 'Honduras',
    region: 'Marcala',
    roast: 'Light',
    price: 22.00,
    notes: ['Jasmine', 'White Peach', 'Honey'],
    process: 'Washed',
    rating: 4.8,
    reviews: 124,
    image: 'https://images.unsplash.com/photo-1559525839-b184a4d698c7?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'c2',
    name: 'Guji Highland',
    origin: 'Ethiopia',
    region: 'Shakisso',
    roast: 'Light-Medium',
    price: 24.50,
    notes: ['Blueberry', 'Bergamot', 'Milk Chocolate'],
    process: 'Natural',
    rating: 4.9,
    reviews: 89,
    image: 'https://images.unsplash.com/photo-1587734195503-904fca47e0e9?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'c3',
    name: 'Antioquia Reserve',
    origin: 'Colombia',
    region: 'Urrao',
    roast: 'Medium',
    price: 20.00,
    notes: ['Caramel', 'Red Apple', 'Walnut'],
    process: 'Honey',
    rating: 4.7,
    reviews: 210,
    image: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'c4',
    name: 'Midnight Express',
    origin: 'Signature Blend',
    region: 'Brazil / Sumatra',
    roast: 'Dark',
    price: 19.00,
    notes: ['Dark Cocoa', 'Molasses', 'Smoky'],
    process: 'Mixed',
    rating: 4.6,
    reviews: 342,
    image: 'https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&q=80&w=800'
  }
];

export const equipment = [
  {
    id: 'e1',
    name: 'Fellow Stagg EKG',
    type: 'Electric Kettle',
    brand: 'Fellow',
    price: 165.00,
    image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'e2',
    name: 'Chemex Classic 8-Cup',
    type: 'Brewer',
    brand: 'Chemex',
    price: 49.50,
    image: 'https://images.unsplash.com/photo-1611162458324-aae1eb4129a4?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'e3',
    name: 'Baratza Encore',
    type: 'Burr Grinder',
    brand: 'Baratza',
    price: 149.00,
    image: 'https://images.unsplash.com/photo-1585237832608-5494d4001c90?auto=format&fit=crop&q=80&w=800'
  }
];

export const subscriptions = [
  {
    id: 's1',
    title: 'The Explorer',
    desc: 'Perfect for the curious palate. One rare single origin delivered every month.',
    price: '22',
    frequency: '/month',
    features: ['1x 340g bag per month', 'Rotating micro-lots', 'Free shipping included', 'Tasting notes cards']
  },
  {
    id: 's2',
    title: 'The Daily Ritual',
    desc: 'Keep your hopper full with our reliable, crowd-pleasing seasonal blends.',
    price: '40',
    frequency: '/month',
    features: ['2x 340g bags per month', 'Choice of core blends', 'Free shipping included', '15% off equipment']
  },
  {
    id: 's3',
    title: 'The Curator',
    desc: 'A hand-picked selection of the world\'s finest coffees for the true connoisseur.',
    price: '58',
    frequency: '/month',
    features: ['3x 340g bags per month', 'Premium estate coffees', 'Priority fulfillment', 'Quarterly coffee cupping']
  }
];

export const faqs = [
  {
    q: "When will my coffee be roasted?",
    a: "We roast to order every Monday and Thursday. Your coffee will ship within 24 hours of roasting to ensure you receive it at its peak flavor window."
  },
  {
    q: "How do I manage my subscription?",
    a: "You can pause, skip, or cancel your subscription at any time through your account dashboard. We'll also send you a reminder 3 days before your next shipment."
  },
  {
    q: "What is your return policy?",
    a: "We want you to love your coffee. If a roast isn't for you, contact us within 14 days for a custom recommendation or store credit. Equipment can be returned unused within 30 days."
  },
  {
    q: "Do you offer wholesale opportunities?",
    a: "Yes! We partner with cafes, restaurants, and offices that value quality. Reach out to our wholesale team for customized programs and equipment support."
  }
];